import React from 'react'
import './Duplicate.css'

import AlertLabel from '../../common/alertLabel/AlertLabel'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip
} from '@mui/material'

const DuplicateTable = ({ title, chipLabel, chipColor, chipBgColor, columns, data }) => {
    return (
        <div className="duplicate-item">
            <div className="duplicate-item-header">
                <AlertLabel message={title} />
                <span className="sub-title">
                    <Chip
                        size="small"
                        label={chipLabel}
                        sx={{
                            color: chipColor,
                            backgroundColor: chipBgColor,
                            padding: '4px',
                            borderRadius: '4px',
                        }}
                    />
                </span>
            </div>
            <TableContainer
                component={Paper}
                className="logs-table-container"
                sx={{
                    maxHeight: 275, // Fixed height for the table
                    overflowY: 'auto', // Enable vertical scrolling
                    overflowX: 'hidden', // Prevent horizontal overflow
                    boxShadow: 'none',
                    borderRadius: '8px',
                }}
            >
                <Table
                    stickyHeader
                    sx={{ borderCollapse: 'collapse' }}
                    className="logs-table"
                >
                    <TableHead>
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell key={index} className="date-time-col">
                                    {column}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, rowIndex) => (
                            <TableRow key={rowIndex} className="log-row">
                                {columns.map((column, colIndex) => (
                                    <TableCell key={colIndex}>
                                        {row[column.toLowerCase().replace(/\s+/g, '')]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

const Duplicate = ({ data }) => {
    const isDataNull = data == null;
    console.log("Duplicate Data: ", data)
    const { duplicateUsers = [], duplicateApplications = [] } = data || {};

    // If both duplicateUsers and duplicateApplications are empty, do not render the component
    if (!isDataNull && duplicateUsers?.length === 0 && duplicateApplications?.length === 0) {
        return null;
    }

    return (
        <div className='duplicate-container review-component-container full-width'>
            <div className='duplicate-header'>
                <h2 className='duplicate-title'>Duplicate Records</h2>
            </div>
            {isDataNull ? (
                <AlertLabel message={"Not Applicable"} type="error" />
            ) : 
            <div className="duplicate-grid">
                {duplicateUsers?.length > 0 && (
                    <DuplicateTable
                        title="Duplicate User Found"
                        chipLabel="Auth0"
                        chipColor="#FFFFFF"
                        chipBgColor="#000000"
                        columns={['User ID']}
                        data={duplicateUsers?.map((user) => ({
                            userid: user.userId,
                        }))}
                    />
                )}

                {duplicateApplications?.length > 0 && (
                    <DuplicateTable
                        title="Duplicate Application Found"
                        chipLabel="Review Center"
                        chipColor="#000000"
                        chipBgColor="#FFCC00"
                        columns={['Application Number', 'Status']}
                        data={duplicateApplications?.map((application) => ({
                            applicationnumber: application.applicationNumber,
                            status: application.applicationStatus,
                        }))}
                    />
                )}
            </div>}
        </div>
    )
}

export default Duplicate